import React from 'react';
import { Box, Typography, Button } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import ContactForm, { Contact } from './components/ContactForm';

interface MultipleContactsProps {
  contacts: Contact[];
  onChange: (contacts: Contact[]) => void;
  errors?: Record<string, any>;
  onValidationError?: (index: number, field: string, message: string) => void;
}

const createEmptyContact = (): Contact => ({
  fullName: '',
  email: '',
  phone: '',
  profiles: [],
  cpf: '',
  jobTitle: '',
});

const MultipleContacts: React.FC<MultipleContactsProps> = ({ 
  contacts, 
  onChange, 
  errors, 
  onValidationError 
}) => {
  const handleAddContact = () => {
    onChange([...contacts, createEmptyContact()]);
  };

  const handleRemove = (index: number) => {
    onChange(contacts.filter((_, i) => i !== index));
  };

  const handleUpdateContact = (index: number, field: keyof Contact, value: any) => {
    const updatedContacts = [...contacts];
    updatedContacts[index] = { ...updatedContacts[index], [field]: value };
    onChange(updatedContacts);
  };

  return (
    <Box>
      <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
        <Typography variant="h6">Contatos</Typography>
        <Button 
          variant="outlined" 
          startIcon={<AddIcon />} 
          onClick={handleAddContact} 
          size="small"
        >
          Adicionar Contato
        </Button>
      </Box>

      {contacts.map((contact, index) => (
        <ContactForm
          key={`contactF_${index}`}
          contact={contact}
          index={index}
          onUpdate={handleUpdateContact}
          onRemove={handleRemove}
          errors={errors}
          onValidationError={onValidationError}
          allContacts={contacts}
        />
      ))}

      {contacts.length === 0 && (
        <Box sx={{ p: 3, textAlign: 'center' }}>
          <Typography color="textSecondary">
            Nenhum contato adicionado. Clique em "Adicionar Contato" para começar.
          </Typography>
        </Box>
      )}
    </Box>
  );
};

export default MultipleContacts; 
